import { render, staticRenderFns } from "./FeaturedUsersLagCv.vue?vue&type=template&id=0a000c52&scoped=true"
import script from "./FeaturedUsersLagCv.vue?vue&type=script&lang=ts"
export * from "./FeaturedUsersLagCv.vue?vue&type=script&lang=ts"
import style0 from "./FeaturedUsersLagCv.vue?vue&type=style&index=0&id=0a000c52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a000c52",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/search/featured-users.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fsearch%2FFeaturedUsersLagCv.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports